import type { IconData } from '@stacksjs/iconify-core'

export const arrowRoadmapFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M4 5.5a2.5 2.5 0 0 0 0 5h31a5.5 5.5 0 1 1 0 11H13C7.201 21.5 2.5 26.201 2.5 32S7.201 42.5 13 42.5h22.599c.105.755.258 1.492.46 2.193a2.5 2.5 0 0 0 3.512 1.547h.001a29 29 0 0 0 2.424-1.372c1.211-.759 2.952-1.965 4.004-3.368a2.5 2.5 0 0 0 0-3c-1.052-1.403-2.793-2.61-4.004-3.369a29 29 0 0 0-2.425-1.371a2.5 2.5 0 0 0-3.511 1.547a16 16 0 0 0-.461 2.193H13a5.5 5.5 0 1 1 0-11h22c5.799 0 10.5-4.701 10.5-10.5S40.799 5.5 35 5.5z\"/><path fill=\"#2859c5\" d=\"M15 1a7 7 0 1 0 0 14a7 7 0 0 0 0-14m3 32a7 7 0 1 0 0 14a7 7 0 0 0 0-14m12-16a7 7 0 1 0 0 14a7 7 0 0 0 0-14\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowRoadmapFlat
